import { __awaiter } from "tslib";
import { buildModuleProps } from 'pathfinder/rules-engine/moduleProps';
import getOptimizelyVariant from 'pathfinder/utils/getOptimizelyVariant';
import { renderVariantA, renderVariantB, renderVariantC, renderVariantD } from './renderVariants';
import { attachTrackEditButton, attachTrackPageSideTools, attachTrackParagraphsEditButtons, trackImpression, } from 'pathfinder/modules/EditButtonLabelsForAnonDesktop/utils/tracking';
const OPTIMIZELY_VARIABLES = {
    EXPERIMENT_ENABLED: 'optimizely_enable_article_edit_button_copy_anon',
    EXPERIMENT_VARIANT: 'optimizely_enable_article_edit_button_copy_anon_variant_name',
};
const VARIANTS = {
    VARIANT_A_EDIT_LABEL: 'variant-a-edit-label',
    VARIANT_B_SOURCE_VIEW_AND_PEN_ICONS: 'variant-b-source-view-and-pen-icons',
    VARIANT_C_SOURCE_VIEW_AND_PEN_WITH_EDIT: 'variant-c-source-view-and-pen-with-edit',
    VARIANT_D_PEN_ONLY_H2: 'variant-d-pen-only-h2',
    VARIANT_E_CONTROL: 'variant-e-control',
};
export const getEditButtonLabelsForAnonDesktopModuleMethods = (moduleConfig) => __awaiter(void 0, void 0, void 0, function* () {
    var _a;
    const moduleProps = buildModuleProps(moduleConfig, {});
    const { log, track } = moduleProps;
    const isForced = (_a = moduleConfig === null || moduleConfig === void 0 ? void 0 : moduleConfig.internalState) === null || _a === void 0 ? void 0 : _a.forced;
    const variant = yield getOptimizelyVariant(isForced, OPTIMIZELY_VARIABLES, VARIANTS);
    if (!variant) {
        return null;
    }
    try {
        const renderVariant = {
            [VARIANTS.VARIANT_A_EDIT_LABEL]: renderVariantA,
            [VARIANTS.VARIANT_B_SOURCE_VIEW_AND_PEN_ICONS]: renderVariantB,
            [VARIANTS.VARIANT_C_SOURCE_VIEW_AND_PEN_WITH_EDIT]: renderVariantC,
            [VARIANTS.VARIANT_D_PEN_ONLY_H2]: renderVariantD,
            [VARIANTS.VARIANT_E_CONTROL]: () => {
                /* do nothing */
            },
        }[variant];
        if (!renderVariant) {
            return null;
        }
        const render = () => {
            renderVariant();
            trackImpression(track, variant);
            attachTrackParagraphsEditButtons(variant);
            attachTrackPageSideTools(variant);
            attachTrackEditButton(variant);
        };
        return {
            render,
        };
    }
    catch (error) {
        log.debug('EditButtonLabelsForAnonDesktopModule error', error);
    }
    // something went wrong - return null
    return null;
});
